import { batchWorkspaceApiConnector } from 'apiConnector/batch-workspace';
import * as apiErrorHelper from 'epic/apiErrorEpicHelper';
import type { BatchImportMetadataRequest, BatchImportMetadataResponse } from 'models/batch/import-metadata';
import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { batchImportMetadataFailed } from 'state/batchForm/batchForm.action';
import * as actionTypes from 'state/batchForm/batchForm.actionTypes';
import { batchImportMetadataReceivedThunk } from 'state/batchForm/importExcel/importExcel.thunks';
import type { EpicWithThunk } from 'state/state.common';
import { getUniqueProductVariations } from 'utils/import/utils/productMappingUtils';

export interface BatchImportMetadataApi {
  getImportMetadata(request: BatchImportMetadataRequest): Observable<BatchImportMetadataResponse>;
}
export function batchImportMetadataEpic(): EpicWithThunk {
  return (action$, _state$, { frontLogger, httpClient }) =>
    action$.pipe(
      ofType(actionTypes.BATCH_IMPORT_METADATA_REQUESTED),
      mergeMap(({ fileParsedResult }) => {
        return batchWorkspaceApiConnector(httpClient)
          .getImportMetadata({ productVariations: getUniqueProductVariations(fileParsedResult.rows) })
          .pipe(
            map(response => batchImportMetadataReceivedThunk(fileParsedResult, response.products)),
            catchError((error: Error) => {
              frontLogger.error('An error occurred during batch import metadata request {@FrontError}', error);
              return of(batchImportMetadataFailed(apiErrorHelper.toApiErrorMessage(error).message));
            }),
          );
      }),
    );
}
